export default __webpack_public_path__ + "static/media/DecentLabs.614ab750.jpg";